/* ==========================================================================
   FOG Theme — Global JS
   ========================================================================== */

(function () {
  'use strict';

  /* ---------- Mobile Menu ---------- */

  const menuToggle = document.querySelector('[data-menu-toggle]');
  const mobileNav = document.querySelector('[data-mobile-nav]');

  if (menuToggle && mobileNav) {
    const fermerMenu = function () {
      mobileNav.classList.remove('is-open');
      menuToggle.setAttribute('aria-expanded', 'false');
      document.body.style.overflow = '';
    };

    menuToggle.addEventListener('click', function () {
      const isOpen = mobileNav.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', isOpen);
      document.body.style.overflow = isOpen ? 'hidden' : '';
    });

    // Un lien du menu doit le refermer : l'ancre « Mes économies » de la home ne recharge pas
    // la page, le menu restait ouvert par-dessus le calculateur avec le défilement bloqué.
    mobileNav.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) fermerMenu();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && mobileNav.classList.contains('is-open')) {
        fermerMenu();
        menuToggle.focus();
      }
    });

    // Le globe de langue est dans la barre : l'ouvrir referme le menu, sinon sa liste
    // s'affichait par-dessus le menu ouvert.
    const langToggle = document.querySelector('.header__lang-toggle');
    if (langToggle) {
      langToggle.addEventListener('click', function () {
        if (mobileNav.classList.contains('is-open')) fermerMenu();
      });
    }

    // Retour arrière servi par le cache de navigation (Safari) : la page revient telle
    // qu'elle a été quittée, menu ouvert et défilement bloqué compris.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) fermerMenu();
    });
  }

  /* ---------- Menus deroulants desktop : ouverture au clic ----------
     Le bouton ouvre et ferme son menu (classe is-open, section-header.css) et tient
     aria-expanded a jour. Un seul menu ouvert a la fois. Le menu se ferme sur un clic
     hors de lui, sur un lien choisi, sur Escape (le focus revient au bouton) et quand
     le focus clavier part ailleurs. Le survol ne fait plus que colorer le bouton. */

  const dropdowns = document.querySelectorAll('.header__dropdown, .header__pro-dropdown');
  const menus = [];

  dropdowns.forEach(function (dropdown) {
    const toggle = dropdown.querySelector('.header__dropdown-toggle, .header__pro-toggle');
    if (toggle) menus.push({ dropdown: dropdown, toggle: toggle });
  });

  const fermer = function (menu) {
    menu.dropdown.classList.remove('is-open');
    menu.toggle.setAttribute('aria-expanded', 'false');
  };

  const fermerTous = function (sauf) {
    menus.forEach(function (menu) { if (menu !== sauf) fermer(menu); });
  };

  menus.forEach(function (menu) {
    menu.toggle.addEventListener('click', function () {
      const ouvrir = !menu.dropdown.classList.contains('is-open');
      fermerTous(menu);
      menu.dropdown.classList.toggle('is-open', ouvrir);
      menu.toggle.setAttribute('aria-expanded', ouvrir ? 'true' : 'false');
    });

    menu.dropdown.addEventListener('click', function (event) {
      if (event.target.closest('a[href]')) fermer(menu);
    });

    // relatedTarget nul = clic sur une zone non focusable (marge du menu) : le clic
    // dans le document decide. Sinon le menu se fermait sous le pointeur.
    menu.dropdown.addEventListener('focusout', function (event) {
      if (event.relatedTarget && !menu.dropdown.contains(event.relatedTarget)) fermer(menu);
    });
  });

  if (menus.length) {
    document.addEventListener('click', function (event) {
      menus.forEach(function (menu) {
        if (!menu.dropdown.contains(event.target)) fermer(menu);
      });
    });

    document.addEventListener('keydown', function (event) {
      if (event.key !== 'Escape') return;
      menus.forEach(function (menu) {
        if (!menu.dropdown.classList.contains('is-open')) return;
        const focusEtaitDedans = menu.dropdown.contains(document.activeElement);
        fermer(menu);
        if (focusEtaitDedans) menu.toggle.focus();
      });
    });

    // Retour arriere servi par le cache de navigation : la page revient menu ouvert.
    window.addEventListener('pageshow', function (event) {
      if (event.persisted) fermerTous();
    });
  }

  /* ---------- Compteur panier ----------
     Un ajout au panier ne rechargeant pas la page, le badge du header doit etre
     rafraichi a la volee : sans cela l'ajout n'avait aucun retour visible dans
     le header, ce qui se remarque surtout sur mobile ou le bouton d'ajout et
     l'icone panier sont eloignes. Les sections emettent `cart:item-added`. */

  document.addEventListener('cart:item-added', function () {
    fetch(window.FOG_ROUTES.url('cart.js'), { headers: { Accept: 'application/json' } })
      .then(function (res) { return res.json(); })
      .then(function (cart) {
        document.querySelectorAll('.header__cart-count').forEach(function (el) {
          // Le compteur B2B est pilote par SparkLayer (b2b-cart-count.js) : on ne
          // lui impose pas la valeur du panier natif.
          if (el.hasAttribute('data-spark-cart-count')) return;
          el.textContent = cart.item_count;
          if (cart.item_count > 0) el.removeAttribute('hidden');
          else el.setAttribute('hidden', '');
        });
      })
      .catch(function () { /* le badge restera a jour au prochain chargement */ });
  });

  /* ---------- Animations decoratives : en pause hors ecran ----------
     Voir base.css (.anim-off). Les animations infinies continuaient de couter du
     calcul a chaque image meme invisibles, ce qui alourdissait le chargement et le
     defilement sur mobile. */

  const animEls = document.querySelectorAll('.fog-eclat, .btn-primary, .badge-glass, .logo-marquee__track');
  if (animEls.length && 'IntersectionObserver' in window) {
    const animObserver = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('anim-off', !entry.isIntersecting);
      });
    });
    animEls.forEach(function (el) { animObserver.observe(el); });
  }
})();
